import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Typography, SpinnerLoader, EnumSpinnerLoaderPosition, Button } from 'shared/ui'
import { Table } from 'shared/ui/TableNew'
import { DeveloperDocsSelect } from 'pages/settings/pages/developer/ui/DeveloperDocsSelect/DeveloperDocsSelect'
import { DeveloperEmptyState } from 'pages/settings/pages/developer/ui/DeveloperEmptyState/DeveloperEmptyState'
import { useApplicationsViewContext } from 'pages/settings/pages/developer/pages/applications/context/applicationsViewContext'
import { applicationsTableColumns } from 'pages/settings/pages/developer/pages/applications/ui/ApplicationsTable/applicationsTableColumns'
import { getApplicationsTableActions } from 'pages/settings/pages/developer/pages/applications/ui/ApplicationsTable/getApplicationsTableActions'
import styles from './styles.module.scss'

export const ApplicationsPage = observer(() => {
  const store = useApplicationsViewContext()
  const hasNoClients = !store.loading && store.clients.length === 0

  const rows = useMemo(() => {
    return store.items.map((item) => {
      item.setActionsProps({
        actions: getApplicationsTableActions(item, store),
      })
      item.setAriaLabel('AuthClientRow')
      return item
    })
  }, [store.items, store])

  if (store.loading) {
    return (
      <div className={styles.loaderWrapper}>
        <SpinnerLoader
          ariaLabel={'ApplicationsPage'}
          position={EnumSpinnerLoaderPosition.Absolute}
          size={32}
        />
      </div>
    )
  }

  return (
    <div className={styles.content}>
      {hasNoClients ? (
        <div className={styles.emptyWrapper}>
          <DeveloperEmptyState
            title='Create your first client'
            text='Create an OAuth client to securely connect your app or integration'
            primaryButtonText='New client'
            onPrimaryClick={store.openNewClientModal}
            ariaLabel='OAuth applications empty state'
          />
        </div>
      ) : (
        <>
          <div className={styles.header}>
            <div className={styles.headerLeft}>
              <Typography variant='heading-lg' ariaLabel='OAuth Applications title'>
                OAuth Applications
              </Typography>
              <Typography
                variant='body-md-regular'
                ariaLabel='OAuth Applications desc'
                color='var(--content-primary-tertiary)'
              >
                Manage OAuth clients for secure API access
              </Typography>
            </div>
            <div className={styles.headerRight}>
              <DeveloperDocsSelect className={styles.headerAction} />
              <Button
                text='New client'
                size='medium'
                icon='add'
                onClick={store.openNewClientModal}
                className={styles.headerAction}
              />
            </div>
          </div>

          <div className={styles.applicationsContent}>
            <Table
              ariaLabel={'ApplicationsTable'}
              store={store.tableStore}
              columns={applicationsTableColumns}
              rows={rows}
              loading={false}
              hidePagination
              defaultColumnCellStyle={{
                height: '41px',
                maxHeight: '41px',
                minHeight: '41px',
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: '4px',
                lineHeight: '41px',
              }}
            />
          </div>
        </>
      )}
    </div>
  )
})
